module.exports = __webpack_public_path__ + "static/media/Notice of Proposal to Revoke a License- 1 Blue Goose Developments Inc..8646815a.pdf";